/**
 * useRemarksCategoryEntryScreen.js
 * --------------------------------
 * Hook for Remarks Category create/edit form screen using shared useMasterEntry.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as remarksCategoryApi from '../api/remarksCategoryApi';

export function useRemarksCategoryEntryScreen() {
  return useMasterEntry({
    entityName: 'Remarks Category',
    apiClient: remarksCategoryApi.remarksCategoryClient,
    fetchDetail: remarksCategoryApi.getRemarksCategoryDetail,
    createItem: remarksCategoryApi.createRemarksCategory,
    updateItem: remarksCategoryApi.updateRemarksCategory,
    initialForm: {
      name: '',
      description: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Remarks Category Name is required.';
      }
      return null;
    },
    listPath: '/masters/remarks-category/list',
    transformPayload: (form, operationalStatus) => ({
      name: form.name.trim(),
      description: form.description ? form.description.trim() : null,
      status: operationalStatus === 'active' ? 'Active' : 'Archived',
    }),
    transformDetail: (detail) => ({
      form: {
        name: detail.name || '',
        description: detail.description || '',
      },
      operationalStatus: detail.status === 'Active' ? 'active' : 'inactive',
    }),
  });
}
